// extracted by mini-css-extract-plugin
module.exports = {"loanPurposePopup":"loan-purpose-popup_loanPurposePopup_aAKWW","commitment-text":"loan-purpose-popup_commitment-text_2at1k"};